"use client";

import { usePathname } from "next/navigation";
import { isAdminPath } from "@/lib/admin-path";

export default function HideOnAdmin({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    const isAdmin = isAdminPath(pathname);

    return (
        <div style={{ display: isAdmin ? 'none' : 'contents' }} suppressHydrationWarning>
            {children}
        </div>
    );
}
